/* eslint-disable no-console */
import { mapCropToERP } from '@/js/mappers/crop';
import CropRepository from '@/js/repositories/cropRepository';
import FieldRepository from '@/js/repositories/fieldRepository';
import {
  removeCrop,
  saveCrop,
} from '@/js/services/contracts/ApiContractsWs';

export default {
  async add(object) {
    await CropRepository.add(object);
    return object;
  },

  async updateById(id, objeto) {
    return CropRepository.updateById(id, objeto);
  },

  async deleteById(id) {
    const crop = await this.getById(id);
    if (!crop.code || crop.code === '') {
      return CropRepository.deleteById(id);
    }
    crop.sync_status = 2;
    return this.updateById(id, crop);
  },

  async getById(id) {
    return CropRepository.getById(id);
  },

  async getAll() {
    return CropRepository.getAll();
  },

  async getAllSyncPending() {
    const syncCrops = await CropRepository.getAllSyncPending();
    for await (const crop of syncCrops) {
      const field = await FieldRepository.getById(crop.field);
      crop.field = field;
    }

    return syncCrops;
  },

  async saveCropToERP(crop) {
    const cropERP = mapCropToERP(crop);
    return saveCrop(cropERP).then(async (response) => {
      if (response.data.Valor) {
        const responseObject = JSON.parse(response.data.Mensaje);
        await this.updateById(crop.id, { sync_status: 0, id_external: responseObject.Code, sync_error_msg: '' });
      } else {
        console.log('error adding crop erp', crop, response.data.Mensaje);
        await this.updateById(crop.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error adding crop erp', crop, error);
      await this.updateById(crop.id, { sync_error_msg: error });
    });
  },

  async removeCropFromERP(crop) {
    return removeCrop(crop).then(async (response) => {
      if (response.data.Valor) {
        // const responseObject = JSON.parse(response.data.Mensaje);
        await CropRepository.deleteById(crop.id);
      } else {
        console.log('error removing crop erp', crop, response.data.Mensaje);
        await this.updateById(crop.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error removing crop erp', crop, error);
      await this.updateById(crop.id, { sync_error_msg: error });
    });
  },

  async syncPendingCrops() {
    const syncCrops = await this.getAllSyncPending();
    for (let i = 0; i < syncCrops.length; i += 1) {
      const crop = syncCrops[i];
      if (crop.sync_status === 1) {
        this.saveCropToERP(crop);
      } else if (crop.sync_status === 2) {
        this.removeCropFromERP(crop);
      }
    }
  },

  async getAllPrimaryKeys() {
    const crops = await this.getAll();
    return crops.map((c) => c.code);
  },
};
